import styled from 'styled-components';

export const AlertWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
`;
